import { useQuery } from "@tanstack/react-query";
import { imagineStore } from "@/stores/imagine.store";
import type {
  GetProjectVariablesResponseBody,
  GetProjectVariablesRequestBody,
} from "@imagine/ai-service/shared-types/route-types";
import { aiServiceFetch } from "@/lib/ai-service-client";
import { HttpError } from "@/lib/http-error";

export function useFetchProjectVariables({ enabled }: { enabled: boolean }) {
  const projectId = imagineStore.use.projectId();

  return useQuery<
    GetProjectVariablesResponseBody,
    Error,
    GetProjectVariablesRequestBody
  >({
    enabled: enabled && Boolean(projectId),
    retry: false,
    queryKey: ["environment-variables", projectId],
    queryFn: async () => {
      const response = await aiServiceFetch(
        `/api/projects/${projectId!}/variables`,
      );

      if (!response.ok) {
        throw await HttpError.fromResponse(response);
      }

      return response.json();
    },
  });
}
